import React from 'react';
import { isNil } from 'lodash';
import AxisConfig from '../AxisConfig';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';
import {
  Controls,
  InlineNumber,
  InlineControl,
  SubHeader,
  Reset,
} from '../../../reporting/sidebar/components';

function HorizontalAxisConfig() {
  const { get } = useReportConfiguration();
  return (
    <AxisConfig axis='horizontal'>
      <SubHeader>Data boundaries</SubHeader>
      <Controls>
        <InlineControl>
          <InlineNumber configurationKey='horizontalMinValue' size='small'>
            Min
          </InlineNumber>
          <InlineNumber configurationKey='horizontalMaxValue' size='small'>
            Max
          </InlineNumber>
          <Reset
            label='Reset horizontal axis boundaries'
            configurationKeys={['horizontalMinValue', 'horizontalMaxValue']}
            className='ml-auto'
            disabled={
              isNil(get('horizontalMinValue')) &&
              isNil(get('horizontalMaxValue'))
            }
          />
        </InlineControl>
      </Controls>
    </AxisConfig>
  );
}
export default HorizontalAxisConfig;
